import { renderToString } from 'react-dom/server';
import ImageCarousel from '../image-carousel';
import './styles.scss';
import ImageCarouselProvider from '../image-carousel/image-carousel-provider';

const MapPopup = ({
    maps,
    title,
    text,
    images,
    category,
    link,
    latitude,
    longitude
  }) => {

    class Popup extends maps.OverlayView {
      constructor() {
        super();
        const popupPos = new maps.LatLng(latitude, longitude);
        this.latlng = popupPos;
      }
  
      async createDiv() {
        this.div = document.createElement("div");
        this.div.style.position = "absolute";
        this.div.style.zIndex = 10000;
        this.div.onclick = (e) => {
          e.stopPropagation();
        };
        this.positionDiv();
        
        this.div.innerHTML = `
          <div class="unit-popup unit-popup--is-loading">
            <div class="unit-popup__bubble">
              <div class="unit-popup__content">
                <button type="button" class="unit-popup__close"></button>
                <div class="unit-popup__content-inner">
                </div>
              </div>
            </div>
          </div>
        `;

        this.appendDivToOverlay();

        const elm = this.div.querySelectorAll('.unit-popup__content-inner');

        const img = images && 
          (`<div class="image-carousel"><div class="image-carousel__scroller">
            ${images.map(image => {
              return `<div class="image-carousel__image"><img src=${image.src} alt=${image.alt} title=${image.title} /></div>`;
            }).join('')}</div></div>`);

        

        elm[0].innerHTML = elm[0].innerHTML + `
          <div class="unit-popup__content-unit">
            <div class="unit-popup__content-unit-images">
              ${img ? img : ''}
            </div>
            <div class="unit-popup__content-unit-inner">
              ${category && `<span class="unit-popup__content-unit-category">${category}</span>`}
              <h4><a href=${link}>${title}</a></h4>
              ${text && `<span class="unit-popup__content-unit-text">${text}</span>`
              }
            </div>
          </div>
        `;

        const button = this.div.querySelectorAll('.unit-popup__close')[0];
        button.onclick = (e) => {
          e.stopPropagation();
          this.remove();
        }

        this.div.firstChild.className = 'unit-popup';

      }

      
  
      appendDivToOverlay() {
        const panes = this.getPanes();
        panes.overlayImage.style.zIndex = 200;
        panes.overlayImage.appendChild(this.div);

        maps.event.addDomListener(this.div, 'DOMMouseScroll', (e) => {
          e.stopPropagation();
        });

        maps.event.addDomListener(this.div, 'mousewheel', (e) => {
          e.stopPropagation();
        });
      }
  
      positionDiv() {
        const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
        //let offset = 25;
        if (point) {
          this.div.style.left = `${point.x}px`;
          this.div.style.top = `${point.y}px`;
        }
      }
  
      async draw() {
        if (!this.div) {
          await this.createDiv();
        }

        this.positionDiv();
      }

      onRemove() {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          delete this.div;
        }
      }

  
      remove() {
        if (this.getMap()) {
          this.setMap(null);
        }        
      }
    }

    return new Popup();
  };
  
  export default MapPopup;
  